import { FC, SVGAttributes } from 'react';

const CashReceiptPurchase: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18.25 8.75L21.5 6.25L24.75 8.75L28 6.25L31.25 8.75L34.5 6.25L37.75 8.75L41 6.25L44.25 8.75L47.5 6.25V45C47.5 49.1421 44.1421 52.5 40 52.5H22.5C18.3579 52.5 15 49.1421 15 45V6.25L18.25 8.75Z"
        fill="#6CA9FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5 16.875C21.4645 16.875 20.625 17.7145 20.625 18.75C20.625 19.7855 21.4645 20.625 22.5 20.625H40C41.0355 20.625 41.875 19.7855 41.875 18.75C41.875 17.7145 41.0355 16.875 40 16.875H22.5ZM30 24.375C28.9645 24.375 28.125 25.2145 28.125 26.25C28.125 27.2855 28.9645 28.125 30 28.125L40 28.125C41.0355 28.125 41.875 27.2855 41.875 26.25C41.875 25.2145 41.0355 24.375 40 24.375L30 24.375Z"
        fill="white"
      />
      <path
        d="M7.5 36.25C6.11929 36.25 5 37.3693 5 38.75V45C5 49.1421 8.35786 52.5 12.5 52.5H40C35.8579 52.5 32.5 49.1421 32.5 45V38.75C32.5 37.3693 31.3807 36.25 30 36.25H7.5Z"
        fill="#C7DEFE"
      />
      <circle cx="46.25" cy="42.5" r="10" fill="#0F73FE" />
      <path
        d="M52.5 41.4555H51.25L51.9792 38.75H50.0463L49.456 41.4555H47.9977L47.3495 38.75H45.2546L44.6181 41.4555H43.1481L42.5579 38.75H40.5208L41.25 41.4555H40V42.9264H41.6435L42.8819 47.5H44.7917L46.25 41.4448L47.7083 47.5H49.6181L50.8565 42.9264H52.5V41.4555ZM43.4722 42.9264H44.2593L43.8542 44.6549L43.4722 42.9264ZM48.7616 44.6871L48.3449 42.9264H49.1435L48.7616 44.6871Z"
        fill="white"
      />
    </svg>
  );
};

export default CashReceiptPurchase;
